import { Box, BoxProps } from "@chakra-ui/react";
import { FiChevronLeft } from "react-icons/fi";

export const ChevronLeft = (props: BoxProps) => {
  return <Box as={FiChevronLeft} height="20px" width="20px" {...props} />;
};
